export default __webpack_public_path__ + "static/media/TNAA-marquee-neon4.7654eabb.jpg";